import React from 'react';
import classnames from 'classnames';

interface IWizardProps {
	className?: string;
	children: React.ReactNode;
}
const Wizard = ({ children, className }: IWizardProps) => {
	return (
		<div className={`body-content wizard ${className}`}>
			{children}
		</div>
	);
};

Wizard.Header = ({ children }: {children: React.ReactNode}) => {
	return (
		<header className="wizard-header">
			{children}
		</header>
	);
};

Wizard.Body = ({ children }: {children: React.ReactNode}) => {
	return (
		<div className="wizard-body">
			{children}
		</div>
	);
};

Wizard.Main = ({ classNames, children }: {classNames?: string, children: React.ReactNode}) => {
	return (
		<main className={classnames('wizard-main', classNames)}>
			{children}
		</main>
	);
};

Wizard.SideBar = ({ children, labelledby }: {children: React.ReactNode; labelledby?: string}) => {
	return (
		<div className="wizard-sidebar" aria-labelledby={labelledby}>
			{children}
		</div>
	);
};

export default Wizard;
